module.exports = __webpack_public_path__ + "img/songji.9396a7ef.png";